// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-count__title[data-v-e23f0918]{margin-bottom:30px;color:#4fc08d}.vue-count__btn[data-v-e23f0918]{margin-top:10px}", ""]);
// Exports
module.exports = exports;
